import React from 'react';
import { Formik } from 'formik';
import Alert from '../../platformui/Alert';
import Label from '../../platformui/Forms/label';
import Field from '../../platformui/Forms/field';
import Confirmation from '../c-confirmation';

const Success = (props) => {
  if (!props.QuestionData) return null;

  const { Success } = props.QuestionData;
  const form = React.useRef(null);

  //Set up error messages
  const errorMessages = [];
  errorMessages['prefix'] = props.Translations.fix;
  errorMessages['required'] = props.Translations.isrequired;
  errorMessages['email'] = props.Translations.notvalidemail;

  return (
    <section className="c-success">
      <h3>{Success.AnswerInformationHeading}</h3>
      <div
        dangerouslySetInnerHTML={{ __html: Success.AnswerInformation }}
      ></div>
      <div className="c-success__alert-container">
        <Alert type="info">
          <p>
            {Success.ErrandIdText} <strong>{Success.ErrandId}</strong>
          </p>
        </Alert>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: Success.ErrandIdInformation }}
      ></div>
      <p>
        {Success.QuestionReplyDateText}{' '}
        <span className="c-success__reply-date">
          {Success.QuestionReplyDate}.
        </span>
      </p>

      <h3>{Success.GetContactedInformationHeading}</h3>
      <div
        dangerouslySetInnerHTML={{ __html: Success.GetContactedInformation }}
      ></div>

      {Success.EmailData.Success && (
        <Confirmation
          heading={Success.EmailData.Success.EmailConfirmationHeading}
          hasCloseButton={false}
          id="message"
        >
          <p>
            <span
              dangerouslySetInnerHTML={{
                __html: Success.EmailData.Success.EmailConfirmation,
              }}
            ></span>
            <strong>{Success.EmailData.Success.QuestionReplyDate}</strong>
          </p>
        </Confirmation>
      )}

      {Success.EmailData.Form && (
        <div className="c-success__submit-container" id="message">
          <Formik
            onSubmit={() => form.current.submit()}
            validate={(values) => {
              const errors = {};
              if (!values[Success.EmailData.Form.EmailField.Name]) {
                errors[Success.EmailData.Form.EmailField.Name] = 'required';
              }
              if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                  values[Success.EmailData.Form.EmailField.Name]
                )
              ) {
                errors[Success.EmailData.Form.EmailField.Name] = 'email';
              }
              return errors;
            }}
            initialValues={{
              [Success.EmailData.Form.EmailField.Name]: '',
            }}
          >
            {(formik) => (
              <form
                onSubmit={formik.handleSubmit}
                ref={form}
                className="c-forms"
                method="post"
                action="#message"
              >
                <Label
                  className="c-forms__label"
                  label={Success.EmailData.Form.EmailField.Label}
                  htmlFor="email"
                  required={true}
                />
                <Field
                  component="input"
                  className="c-forms__input"
                  type="email"
                  placeholder={Success.EmailData.Form.EmailField.Placeholder}
                  label={Success.EmailData.Form.EmailField.Label}
                  name={Success.EmailData.Form.EmailField.Name}
                  errorType={
                    formik.errors[Success.EmailData.Form.EmailField.Name]
                  }
                  errorMessages={errorMessages}
                  isValid={
                    !formik.errors[Success.EmailData.Form.EmailField.Name]
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values[Success.EmailData.Form.EmailField.Name]}
                  isTouched={
                    formik.touched[Success.EmailData.Form.EmailField.Name]
                  }
                />
                <input
                  type="hidden"
                  value={Success.ErrandId}
                  name="controlnumber"
                />
                <button className="c-forms__button" type="submit">
                  {Success.EmailData.Form.SubmitButton.Label}
                </button>
              </form>
            )}
          </Formik>
        </div>
      )}
    </section>
  );
};

export default Success;
